import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e73bf34"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "show"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "image-grid" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "image-container upload-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "fileInput",
  class: "label-input"
}, "+", -1))
const _hoisted_8 = { class: "buttons-container" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.id,
                class: "image-container"
              }, [
                _createElementVNode("img", {
                  src: image.original,
                  class: "thumbnail"
                }, null, 8, _hoisted_4),
                _createElementVNode("button", {
                  class: "delete-btn",
                  onClick: ($event: any) => (_ctx.deleteImage(image.id, index))
                }, " X ", 8, _hoisted_5)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("input", {
                type: "file",
                multiple: "",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelected && _ctx.onFilesSelected(...args))),
                id: "fileInput"
              }, null, 32),
              _hoisted_7
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadImages && _ctx.uploadImages(...args))),
              class: "upload-btn"
            }, [
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Uploading..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "Upload"))
            ]),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
              class: "cancel-btn"
            }, "Cancel")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}